export default [{
    text: 'Высокое',
    value: 'high'
}, {
    text: 'Среднее',
    value: 'middle'
}, {
    text: 'Низкое',
    value: 'low'
}];
